import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { postDocuments } from '@zurich/api/document';
import { useFetchApi, useTranslation } from '@zurich/common/hooks';
import { fileUploadSelectorFamily } from '@zurich/common/recoil';
export function usePostDocumentUpload(id) {
    const { t } = useTranslation();
    const files = useRecoilValue(fileUploadSelectorFamily(id));
    const { fetchApi } = useFetchApi();
    const extractedFiles = useMemo(() => files?.map((item) => item.file) ?? [], [files]);
    const handleFetch = async ({ processInstanceId }) => {
        const downloads = extractedFiles?.map((file) => {
            const formData = new FormData();
            formData.set('file', file);
            return fetchApi(postDocuments, {
                body: formData,
                vars: {
                    processInstanceId,
                },
            }, {
                errorText: t('party:document.errors.uploadDocument'),
            });
        }) ?? [];
        const response = await Promise.all(downloads).catch((_e) => {
            throw new Error(t('party:document.errors.uploadDocument'));
        });
        return response.filter((res) => res);
    };
    return handleFetch;
}
